import * as Yup from 'yup'

export const LoginProjectManagerSchema = Yup.object().shape({
  email: Yup.string()
    .required('Email is required.')
    .email('Enter a valid email address.')
    .matches(
      /^[\w-.]+@(reachbird\.io|verycreatives\.com)$/,
      'Sign-in is only allowed for @reachbird.io or @verycreatives.com addresses.'
    ),
  password: Yup.string()
    .required('Password is required.')
    .min(8, 'Password must be at least 8 characters.')
    .test({
      name: 'passwordComplexity',
      test: (password) =>
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&_])[^\s]{8,}$/.test(password),
      message:
        'Password must include uppercase, lowercase, a number, and a special character (#@$!%*?&_).',
    }),
})
